/** Completion frame the notification socket delivers for one record create. */
export interface CreateCompletedFrame {
  correlationId: string;
  resource: string;
  resourceVersion?: string;
  primaryKey: string;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

/**
 * One record create reported by the socket, or `null` for any other frame.
 *
 * `correlationId` sits beside the inner `data`, not inside it. One run emits
 * several creates (the material, then its attributes, sourcing, and so on).
 */
export const readCreateCompleted = (message: unknown): CreateCompletedFrame | null => {
  if (!isRecord(message) || message.action !== "notification" || !isRecord(message.data)) {
    return null;
  }

  const note = message.data;

  if (note.type !== "BOS_CREATE_COMPLETED" || typeof note.correlationId !== "string") {
    return null;
  }

  if (!note.correlationId || !isRecord(note.data)) {
    return null;
  }

  const body = note.data;
  const resource = body.resource;
  const primaryKey = body.primaryKey;

  if (typeof resource !== "string" || typeof primaryKey !== "string" || !primaryKey) {
    return null;
  }

  return {
    correlationId: note.correlationId,
    resource,
    resourceVersion: typeof body.resourceVersion === "string" ? body.resourceVersion : undefined,
    primaryKey,
  };
};
